import Header from "./components/Header";
import LeftSidebar from "./components/LeftSidebar";
import MainContent from "./components/MainContent";
import RightSidebar from "./components/RightSidebar";
import Footer from "./components/Footer";
import MobileBottomSidebar from "./components/MobileBottomSidebar";
import { useHomeData } from "@/hooks/useHomeData";
import { useRssAutoFetcher } from "@/hooks/useRssAutoFetcher";

export default function Home() {
  const {
    notices,
    noticesLoading,
    hotIssues,
    hotIssuesLoading,
    communityPosts,
    communityPostsLoading,
    sportsArticles,
    sportsArticlesLoading,
  } = useHomeData();
  useRssAutoFetcher();

  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <div className="max-w-[1540px] mx-auto px-3 md:px-4 py-3">
        <div className="grid grid-cols-1 lg:grid-cols-[260px_1fr_270px] gap-3">
          {/* Left Sidebar - desktop only */}
          <div className="hidden lg:block">
            <LeftSidebar notices={notices} noticesLoading={noticesLoading} />
          </div>

          {/* Main Content */}
          <MainContent
            hotIssues={hotIssues}
            hotIssuesLoading={hotIssuesLoading}
            communityPosts={communityPosts}
            communityPostsLoading={communityPostsLoading}
            sportsArticles={sportsArticles}
            sportsArticlesLoading={sportsArticlesLoading}
          />

          {/* Right Sidebar - desktop only */}
          <div className="hidden lg:block">
            <RightSidebar />
          </div>
        </div>

        {/* Mobile sidebar sections */}
        <MobileBottomSidebar />
      </div>

      <Footer />
    </div>
  );
}